/**
 * エラーコード定義
 */

// クライアントバリデーション例外
export const ERR_CODE_CLIENT_VALID = 'ERR001'
// サーババリデーション例外
export const ERR_CODE_SERVER_VALID = 'ERR002'
// リソースなし
export const ERR_CODE_WEB_API_NOT_FOUND = 'ERR003'
// セッション切れ
export const ERR_CODE_ABORT_SESSION = 'ERR004'
// 禁止されています
export const ERR_CODE_FORBIDDEN = 'ERR005'
// データ構造が不正
export const ERR_CODE_BAD_DATA_STRUCTURE = 'ERR006'
// 未ロードのデータにアクセス
export const ERR_CODE_DATA_LOAD = 'ERR007'

// 予期せぬエラー
export const ERR_CODE_UNEXPECTED = 'ERR999'
